<template>
  <v-row>
    <v-col md="6" lg="6" class="hidden-xs-only">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-avatar-two-line"
        min-height="120"
      >
      </v-skeleton-loader>
    </v-col>
    <v-col md="6" lg="6" class="hidden-xs-only">
      <v-skeleton-loader
        class="mx-auto"
        type="actions"
        height="120"
      ></v-skeleton-loader>
    </v-col>
    <v-col cols="12" class="hidden-sm-and-up">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-avatar-two-line"
        min-height="120"
      >
      </v-skeleton-loader>
    </v-col>
    <v-col cols="12" class="hidden-sm-and-up">
      <v-skeleton-loader
        class="mx-auto"
        type="button@3"
        min-height="120"
      >
      </v-skeleton-loader>
    </v-col>

  </v-row>

</template>

<script>
    export default {
        name: "profileHeadingBoiler"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Boilerpalettes/profileHeadingBoiler.vue